/**
 * Import context and convert to namespaced key/value object
 * @param  {Context} context
 * @param  {Function|null} filter
 * @return {Object}
 */
export default function autoload (context, filter=defaultFilter) {
  const modules = {}

  context
    .keys()
    .forEach(filepath => {
      const key = toKey(filepath, filter)
      modules[key] = context(filepath).default || context(filepath)
    })

  return modules
}

/**
 * Convert filename to a useable key
 * @example "campaign.store.js" => "campaign"
 * @param  {String} filename
 * @return {String}
 */
function defaultFilter (filename) {
  return filename.split('.').shift()
}

/**
 * Convert filepath to a useable key
 * @example "./modules/campaign/campaign.store.js" => "campaign"
 * @param  {String} filename
 * @param  {Function|null} filter
 * @return {String}
 */
function toKey (filepath, filter) {
  const filename = filepath.split('/').pop()
  return filter(filename)
}

// const autoload = function (context) {
//   return context.keys()
//     .reduce((result, filename) => ([
//       ...context(filename).default,
//       ...result
//     ]), [])
// }
